import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { User } from "./user";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable()
export class SharedCommonService {

    FullScreen: Subject<boolean>;
    
    OnMobile: any;

    constructor(private http: HttpClient) {
        this.FullScreen = new Subject<boolean>();

        this.OnMobile = this.DeviceDetection();
        
        if (!this.OnMobile) {
            if (window.screen.width < 1300) {
                this.OnMobile = true;
            };
        };

        //ENSURE THAT ONMOBILE IS DYNAMIC TO RESIZE
        //THIS IS MAINLY FOR TESTING PURPOSE WHEN
        //SWITCHING BETWEEN MOBILE AND DESKTOP VIEW
        window.addEventListener("resize", (event) => {
            this.OnMobile = this.DeviceDetection();
            if (!this.OnMobile) {
                if (window.screen.width < 1300) {
                    this.OnMobile = true;
                };
            };
        });
    };

    getVariable(_var: string): any {
        if (this[_var] != undefined)
            return this[_var].asObservable();
        return null;
    };

    setVariable(_var: string, _val): void {
        if (this.getVariable(_var) != null)
          this[_var].next(_val);
    };

    GetUserDetails(): Observable<any> {
        return this.http.get("/user/details");
    };

    //IMPROVISED CLASS TO IDENTIFY IF USER IS ON MOBILE DEVICE
    public DeviceDetection() {
        var Android = function () { return navigator.userAgent.match(/Android/i) };
        var BlackBerry = function () { return navigator.userAgent.match(/BlackBerry/i) };
        var iOS = function () { return navigator.userAgent.match(/iPhone|iPad|iPod/i) };
        var Opera = function () { return navigator.userAgent.match(/Opera Mini/i) };
        var Windows = function () { return navigator.userAgent.match(/IEMobile/i) };
        var any = function () { return (Android() || BlackBerry() || iOS() || Opera() || Windows()) };

        return any();
    };

    //TOGGLE CLICK OF GIVEN ELEMENT
    public ToggleMenu(id: string) {
        document.getElementById(id).click();
    };

}



// WEBPACK FOOTER //
// ./src/app/shared/shared-common.service.ts